module.exports = __webpack_public_path__ + "static/media/MEV.c8d18f15.jpg";